import gql from 'graphql-tag';

export const TENANCY_INFO_FRAGMENT = gql`
    fragment TENANCY_INFO_FRAGMENT on ListingData {
        administrationFees
    }
`;
